export const SET_HEALTHOVERVIEW = 'SET_HEALTHOVERVIEW';
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION';
export const SET_RECOMMENDATION_DATA = 'SET_RECOMMENDATION_DATA';
export const SET_ERROR_FIELDS = 'SET_ERROR_FIELDS';
export const SET_REQUIRED_FIELDS = 'SET_REQUIRED_FIELDS';
